/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * VisitIdsDtoBase
 * auto generated base class for the model VisitIdsDtoModel.
 */
export const VisitIdsDtoModelBase = ModelBase
  .named('VisitIdsDto')
  .props({
    __typename: types.optional(types.literal("VisitIdsDto"), "VisitIdsDto"),
    id: types.union(types.undefined, types.integer),
    uuid: types.union(types.undefined, types.string),
    eventUuid: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class VisitIdsDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get uuid() { return this.__attr(`uuid`) }
  get eventUuid() { return this.__attr(`eventUuid`) }
}
export function selectFromVisitIdsDto() {
  return new VisitIdsDtoModelSelector()
}

export const visitIdsDtoModelPrimitives = selectFromVisitIdsDto().uuid.eventUuid
